import React from 'react';
import { Link } from '@infoods/lifebase-ui';

import classes from './VideoList.module.scss';
import { Video } from '../../../interface/video';
import { VideoPreview } from '../../../components/VideoPreview/VideoPreview';

type VideoListProps = {
  videos: Video[];
  /**
   * The document links indexed by the video's rendered position.
   * A `null`/undefined slot means no document — the link is not rendered.
   * See constants/videoDocuments.
   */
  docLinks?: (string | null)[];
};

const VideoList = ({ videos, docLinks }: VideoListProps) => {
  return (
    <div className={classes.videoBox}>
      {videos.map((video, index) => {
        const docLink = docLinks?.[index];

        return (
          <div key={video.id}>
            <VideoPreview
              imgSrc={video.image}
              videoLink={video.youtubevideo}
              className={classes.videoPreview}
            />
            <p className={classes.videoTitle}>{video.title}</p>
            {docLink && (
              <Link
                className={classes.fileLink}
                color="info"
                href={docLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                Open file here &gt;
              </Link>
            )}
          </div>
        );
      })}
    </div>
  );
};

export { VideoList };
